/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';

const SimulationDispatcher = can.Construct('SimulationDispatcher', {
    callbacks: {},
    delayedCallbacks: {},

    dispatchDelayed(event, args) {
        this.delayedCallbacks[event] = cb => cb(event, args);

        if (this.callbacks[event]) {
            this.callbacks[event].forEach(cb => cb(event, args))
        }
    }
});

can.extend(SimulationDispatcher.prototype, can.event, {
    on(event, cb) {
        const callbacks = this.callbacks[event] || (this.callbacks[event] = []);

        callbacks.push(cb);
        can.event.on.call(this, event, cb);
        if (this.delayedCallbacks[event]) {
            this.delayedCallbacks[event](cb);
        }
    },

    off(event, cb) {
        _.each(this.callbacks[event], (cb, i) => {
            if (cb === cb) {
                this.callbacks[event].splice(i, 1);
            }
        });
    }
});

const dispatcher = new SimulationDispatcher();

export default dispatcher;
